import { object, string } from 'yup';

import { BREEDING_STATUSES, EVENT_TYPES } from './breeding';
import { MAJOR_MEASURE_TYPES, MINOR_MEASURE_TYPES, TREATMENT_TYPES } from './livestock';

export const BREEDING_CSV_VALIDATION_SCHEMA = object({
  breeding_status: string().oneOf(BREEDING_STATUSES).required(),
  management_id: string().required(),
  event_type: string().oneOf(EVENT_TYPES).required(),
  start_date: string().required()
});

export const LIVESTOCK_CSV_VALIDATION_SCHEMA = object({
  management_tag_id: string().required(),
  dob: string().required(),
  specie: string().required(),
  sex: string().oneOf(['male', 'female']).required()
});

export const MEASURES_CSV_VALIDATION_SCHEMA = object({
  livestock_id: string().required(),
  major_measure_type: string().oneOf(MAJOR_MEASURE_TYPES).required(),
  minor_measure_type: string().oneOf(MINOR_MEASURE_TYPES).required(),
  measurement: string().matches(/^\d+$/, 'measurement must be a number').required(),
  uom: string().required(),
  measurement_date: string().required(),
  comments: string().matches(/^(?!\d+$).+$/, 'comments must be a string')
});

export const TREATMENT_CSV_VALIDATION_SCHEMA = object({
  livestock_id: string().required(),
  management_id: string().required(),
  treatment_type: string().oneOf(TREATMENT_TYPES).required(),
  treatment_date: string().required(),
  treatment: string().required(),
  cost: string().matches(/^\d+(\.\d{1,2})?$/, 'cost must be a number').required()
});

export const GATEWAYS_CSV_VALIDATION_SCHEMA = object({
  appeui: string().required(),
  gweui: string().required(),
  name: string().required(),
  identifier: string().required(),
  version: string().required(),
  carrier_type: string().required()
});

export const TAGS_CSV_VALIDATION_SCHEMA = object({
  deveui: string().required()
});
